"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
export default function CommonAnimationHeight(t0) {
  const $ = _c(19);
  const {
    className,
    children,
    onAnimationCompleted,
    onAnimationStart
  } = t0;
  const containerRef = useRef(null);
  const [height, setHeight] = useState("auto");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!containerRef.current) {
        return;
      }
      const resizeObserver = new ResizeObserver(entries => {
        const observedHeight = entries[0]?.contentRect.height;
        setHeight(observedHeight);
      });
      resizeObserver.observe(containerRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = `${className} tw-overflow-hidden`;
  let t4;
  let t5;
  if ($[2] !== height) {
    t4 = {
      height
    };
    t5 = {
      height
    };
    $[2] = height;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 0.3
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onAnimationStart) {
    t7 = onAnimationStart && {
      onAnimationStart
    };
    $[6] = onAnimationStart;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== onAnimationCompleted) {
    t8 = onAnimationCompleted && {
      onAnimationComplete: onAnimationCompleted
    };
    $[8] = onAnimationCompleted;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== children) {
    t9 = <div ref={containerRef}>{children}</div>;
    $[10] = children;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <motion.div className={t3} style={t4} animate={t5} transition={t6} {...t7} {...t8}>{t9}</motion.div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}